import {
    LatestNewsList,
    LatestNewBoxLeft,
    LatestNewBoxRight,
    FlexCenter,
} from './newsNewBoxElements'
import Grid from '@material-ui/core/Grid';
import newsApi from '../../api/newsApi'
import { useEffect, useState } from 'react';
import NewsItem from '../newsItem';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

const NewsNewBox = ({category, _limit, skip, small, viewmore}) => {
    const [news, setNews] = useState({
        left: [],
        right: []
    })
    const [totalRows, setTotalRows] = useState(0)
    const [loading, setLoading] = useState(true)
    const [innerWidth, setInnerWidth] = useState(window.innerWidth)
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        const handleResize = () => setInnerWidth(window.innerWidth)
        window.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    useEffect(() => {
        (async () => {
            const response = await newsApi.getNewsNew({category, _limit, skip})
            setNews({
                left: response.news.data.slice(0, Math.ceil(response.news.data.length/2)),
                right: response.news.data.slice(Math.ceil(response.news.data.length/2))
            })
            setTotalRows(response.news.totalRows.count - skip)
            setLoading(false)
        })()
    },[category, _limit, skip])

    const handleLoadmore = async () => {
        setLoading(true)
        const response = await newsApi.getNewsNew({category, _limit, skip: news.left.length + news.right.length + skip})
        setNews({
            left: [...news.left, ...response.news.data.slice(0, Math.ceil(response.news.data.length/2))],
            right: [...news.right, ...response.news.data.slice(Math.ceil(response.news.data.length/2))]
        })
        setLoading(false)
    }


    if(loading) return <></>
  

    return (
        <>
            <Grid container spacing={isSmall ? 1 : 0}>
                <Grid item xs={6}>
                    <LatestNewBoxLeft>
                        <LatestNewsList>
                            {news.left.map((news, index) => (
                                <NewsItem fixedheight index={index} key={news._id} small={small} news={news} type={innerWidth > 1023 && !small && (index + 1) % 5 === 0 && index < 16 && index > 1 ? 'big':''}/>
                            ))}
                        </LatestNewsList>
                    </LatestNewBoxLeft>
                </Grid>
                <Grid item xs={6}>
                    <LatestNewBoxRight>
                        <LatestNewsList>
                            {news.right.map((news, index) => (
                                <NewsItem fixedheight index={index} key={news._id} small={small} news={news} type={innerWidth > 1023 && !small && index % 5 === 0 && index < 11 ? 'big':''}/>
                            ))}
                            
                        </LatestNewsList>
                    </LatestNewBoxRight>
                </Grid>
                {viewmore && news.left.length + news.right.length < totalRows &&
                    <FlexCenter>
                        <Button onClick={handleLoadmore} color="primary">Xem thêm</Button>
                    </FlexCenter>
                }
            </Grid>
        </>
    )
}

export default NewsNewBox
